var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#912626;}\n\t.st1{fill:#C6302B;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#621B1C;}\n\t.st4{fill:#9A2928;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M418.2,334.2c-19.5,10.2-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 c-17-8.1-124.4-51.5-143.7-60.7c-9.7-4.6-14.8-8.5-14.8-12.2v-36.9c0,0,139.8-30.4,162.4-38.5c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,134,27.8,153,34.7c0,0,0,33,0,36.4C432.5,325,428.1,329,418.2,334.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M418.2,297.5c-19.5,10.1-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 c-17-8.1-124.3-51.5-143.7-60.7c-19.3-9.2-19.7-15.6-0.7-23c19-7.4,125.8-49.3,148.4-57.4c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,119.5,47,138.5,53.9C436.9,281.7,437.7,287.4,418.2,297.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M418.2,274.5c-19.5,10.2-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 c-17-8.1-124.4-51.5-143.7-60.7c-9.7-4.6-14.8-8.5-14.8-12.2v-36.9c0,0,139.8-30.4,162.4-38.5c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,134,27.8,153,34.7c0,0,0,33,0,36.4C432.5,265.4,428.1,269.4,418.2,274.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M418.2,237.8c-19.5,10.2-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 c-17-8.1-124.3-51.5-143.7-60.7c-19.3-9.2-19.7-15.6-0.7-23.1c19-7.4,125.8-49.3,148.4-57.4c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,119.5,47,138.5,53.9C436.9,222,437.7,227.7,418.2,237.8L418.2,237.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M418.2,212.6c-19.5,10.2-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 c-17-8.1-124.4-51.5-143.7-60.7c-9.7-4.6-14.8-8.5-14.8-12.2v-36.9c0,0,139.8-30.4,162.4-38.5c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,134,27.8,153,34.7c0,0,0,33,0,36.4C432.5,203.4,428.1,207.4,418.2,212.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M418.2,175.9c-19.5,10.2-120.4,51.6-141.9,62.8c-21.5,11.2-33.4,11.1-50.4,3 S101.6,190.3,82.3,181c-19.3-9.2-19.7-15.6-0.7-23.1c19-7.4,125.8-49.3,148.4-57.4c22.6-8.1,30.4-8.4,49.6-1.4 c19.2,7,119.5,47,138.5,53.9C436.9,160,437.7,165.8,418.2,175.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_9_",
    className: "st2",
    points: "294.6,140 263.2,143.3 256.2,160.2 244.8,141.3 208.6,138.1 235.7,128.3 227.5,113.4  252.9,123.3 276.7,115.5 270.3,130.9 294.6,140  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_10_",
    className: "st2",
    points: "254.3,222.1 195.8,197.8 279.7,184.9 254.3,222.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st2",
    d: "M173.1,149.4c24.8,0,44.9,7.8,44.9,17.4c0,9.6-20.1,17.4-44.9,17.4c-24.8,0-44.9-7.8-44.9-17.4 C128.3,157.2,148.4,149.4,173.1,149.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_12_",
    className: "st3",
    points: "331.7,144.7 381.4,164.3 331.7,183.9 331.7,144.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_13_",
    className: "st4",
    points: "276.7,166.4 331.7,144.7 331.7,183.9 326.3,186 276.7,166.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.3d8c665ea11bb76e53b282c01fd7919b.svg";
export { ForwardRef as ReactComponent };